import React from "react";
import Icon from "../Icon/Icon";
import Button from "../Button/Button";
import { getNameFromFileAttributeRef } from "@imminently/decisively-core";

export interface DownloadFileButtonProps {
  reference: string;
  hideName?: boolean;
  title?: string;
}

const DownloadFileButton = (props: DownloadFileButtonProps) => {
  const { reference, hideName = false, title } = props;

  const handleDownload = () => {
    try {
      const match = reference.match(/^data:id=(.*);base64,([-A-Za-z0-9+/=]*)$/);
      if (!match) {
        console.error("Invalid file reference format");
        return;
      }

      const [, id, base64Data] = match;
      const fileName = getNameFromFileAttributeRef(reference);
      
      // Decode base64 data
      const binaryString = atob(base64Data);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      
      // Create blob and download
      const blob = new Blob([bytes]);
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <Button icon
      onClick={handleDownload}      label={title || "Download"}
    >
      <Icon name="download" />
    </Button>
  );
};

export default DownloadFileButton;


